export const DB_NAME = 'LM';
export const STORE_NAME = 'store';
export const STORE_KEYS = { accessToken: 'accessToken', refreshToken: 'refreshToken' };
